const routes = {
  index: {
    path: 'index.consult.train',
    url: '/train',
  },
  home: {
    path: 'index.consult.train.home',
    url: '/accueil',
  },
  new: {
    path: 'index.consult.train.new',
    url: '/creer',
  },
  edit: {
    path: 'index.consult.train.edit',
    url: '/modifier',
  },
  details: {
    path: 'index.consult.train.details',
    url: '/details',
  },
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/train/routes.js